import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './AppLayout.css';

/**
 * AppLayout – root shell: sidebar + topbar + main content
 */
export default function AppLayout({
  active, collapsed, mobileOpen,
  onNavigate, onToggle,
  activeSection, activePage,
  user, onLogout,
  navConfig,
  children,
}) {
  return (
    <div className="app-layout">
      {mobileOpen && (
        <div className="app-layout__overlay" onClick={onToggle} aria-hidden="true" />
      )}

      <Sidebar
        active={active}
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onNavigate={onNavigate}
        user={user}
        navConfig={navConfig}
      />

      <div className="app-layout__main">
        <Topbar
          section={activeSection}
          page={activePage}
          onToggle={onToggle}
          user={user}
          onLogout={onLogout}
        />
        <main className="app-layout__content">
          {children}
        </main>
      </div>
    </div>
  );
}
